import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import VarianceAnalysisWidget from "../../../finance/widgets/variance-analysis";

class TeamReportsSection3Step2 extends PureComponent {
  get left_content() {
    return (
      <span>
        FP&A is a process that many businesses perform periodically to evaluate
        how well management was able to meet expectations.
        <br />
        <br />
        In this game, the CEO sets expectation when s/he makes financial
        projections. Investors rely on those projections to derive a value of
        the business.
        <br />
        <br />
        The FP&A (to the right) is comparing your expected vs. actual Income
        Statement.
      </span>
    );
  }

  get right_content() {
    const { actual, expected, current_year } = this.props;

    return (
      <VarianceAnalysisWidget
        actual={actual}
        expected={expected}
        current_year={current_year}
      />
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Financing Planning and Analysis (FP&A) Page"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection3Step2;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-3/step-2.js